import React, { useRef, useState, useEffect } from 'react';
import PageEditor from '../PageEditor/PageEditor';
import './SelfPublish.css';
import mixins from '../../app-services/mixins';
import { readUrl } from '../PageEditor/support';

import FrontCover from "./FrontCover.txt";
import Copyright from "./Copyright.txt";
import Titlepage from "./Titlepage.txt";
import Dedication from "./Dedication.txt";
import Chaptertitle from "./Chaptertitle.txt";
import Authorandartist from "./Authorandartist.txt";
import Backcover from "./Backcover.txt";

import Personalize from '../common/Personalize/Personalize';

import ImageTextBolierplate from './Bolierplates/ImageTextBolierplate';

import { withRouter } from "../../app-services/lib/router-compat";

function generateBlankPage(count = 55) {
    let arr = [];
    arr.length = count;
    arr = arr.fill({});
    let pages = arr.map((v, i) => {
        return {
            pagetype: "halftexthalfimage",
            name: `Page${i + 6}`,
            label: `Page ${i + 6}`,
            content: ImageTextBolierplate,
            contentSize:500
        }
    });
    return pages;
}

export function SelfPublish(props) {
    const BOOKID = props.match.params.id;
    const book = props.store.book.selfpublish.chapterbook;
    const selfRef = useRef(null);
    if (!selfRef.current) {
        selfRef.current = {};
    }
    const self = selfRef.current;
    self.BOOKID = BOOKID;
    self.props = props;

    const [state, setStateRaw] = useState(() => ({
        staticPages: {
            frontpage: FrontCover,
            copyright: Copyright,
            titlepage: Titlepage,
            dedication: Dedication,
            chaptertitle: Chaptertitle,
            authorandartist: Authorandartist,
            backcover: Backcover
        },
        savedBook: {},
        bolierplates: {},
        svgs: {},
        pages: [
            {
                pagetype: "fulltext",
                contentSize: 200,
                name: `frontpage`,
                label: `Front Cover`,
                content: book && book[`frontpage`]
            },
            {
                pagetype: "fulltext",
                contentSize: 800,
                name: `titlepage`,
                label: `Titlepage`,
                content: book && book[`titlepage`]
            },
            {
                pagetype: "fulltext",
                name: `copyright`,
                label: `Copyright`,
                content: book && book[`copyright`]
            },
            {
                pagetype: "fulltext",
                name: `dedication`,
                label: `Dedication`,
                content: book && book[`dedication`]
            },
            {
                pagetype: "fulltext",
                name: `chaptertitle`,
                label: `Chapter Title`,
                content: book && book[`chaptertitle`]
            },

            ...generateBlankPage(55),
            {
                pagetype: "fulltext",
                name: `authorandartist`,
                label: `Author and Artist`,
                content: book && book[`authorandartist`]
            },
            {
                pagetype: "fulltext",
                name: `backcover`,
                label: `Back Cover`,
                content: book && book[`backcover`]
            },
        ],
        overlayStyle: {}
    }));

    self.state = state;
    self.setState = (update, callback) => {
        setStateRaw((prev) => {
            const next = typeof update === "function" ? update(prev) : { ...prev, ...update };
            return next;
        });
        if (callback) setTimeout(callback, 0);
    };

    initialConstruct.bind(self)('SelfPublish', props);

    self.getContent = (content, page) => {
        let ele = mixins.getDataNode(content);
        content = ele.innerHTML;
        return content;
    };

    self.getLatestBook = () => {
        return new Promise((resolve, reject) => {
            api.getUpdatedSelfBook({
                sessionId: localStorage.getItem("sessionID") || null,
                type:"chapterbook"
            }).then((responce) => {
                if (responce && responce.data) {
                    let payload = responce.data;
                    self.setState((prev) => ({
                        ...prev,
                        savedBook: payload
                    }));
                    resolve(payload);
                } else {
                    resolve(self.state.savedBook);
                }
            }).catch(reject);
        })
    };

    self.onSave = (payload, saveSelf) => {
        const saveBOOKID = saveSelf.BOOKID;
        const { savedBook } = saveSelf.state;
        return new Promise((resolve, reject) => {
            mixins.checkLogin(saveSelf.history).then(() => {
                if (savedBook && savedBook.id) {
                    api.updateSelfPublish({
                        bookId: saveBOOKID,
                        savedBook: JSON.stringify(payload),
                        option: "dynamic",
                        sessionId: localStorage.getItem("sessionID") || null,
                        type:"chapterbook"
                    }, savedBook.id).then((responce) => {
                        saveSelf.getLatestBook().then((responce) => {
                            resolve(responce);
                        }).catch(reject);
                    });
                } else {
                    api.createSelfPublish({
                        bookId: saveBOOKID,
                        savedBook: JSON.stringify(payload),
                        option: "dynamic",
                        sessionId: localStorage.getItem("sessionID") || null,
                        file: null,
                        type:"chapterbook"
                    }).then((responce) => {
                        saveSelf.history.push(saveSelf.history.location.pathname+`/${responce.data.id}`);
                        setTimeout(()=>{
                            saveSelf.getLatestBook("createmsg").then((responce) => {
                                resolve(responce);
                            }).catch(reject);
                        });
                    });
                }     
            });
        });
    };

    self.onUpdate = () => {

    };

    self.updateBoilerplate = () => {
        return new Promise((resolve, reject) => {
            let { staticPages } = self.state;
            let promises = Object.entries(staticPages).map(([key, url]) => {
                return new Promise((resolve, reject) => {
                    readUrl(url).then((responce) => resolve({ key, responce })).catch(reject)
                })
            });
            let load = loader("Loading boilerplates please wait...");
            Promise.all(promises).then((responce) => {
                let bolierplates = responce.reduce((o, n) => ({ ...o, [n.key]: n.responce }), {});
                self.setState((prev) => ({
                    ...prev,
                    bolierplates: bolierplates
                }));
                load.close();
                resolve(bolierplates);
            }).catch(()=>{load.close();reject();});
        });
    };

    self.onProceed = () => {
        self.updateData();
    };

    self.collectInfo = () => {
        let modal = alert((alertProps) => (<Personalize alert={alertProps} onProceed={() => self.onProceed()} />), "", "model", {
            footer: false,
            class: "personalize-col col-12 col-md-10 col-lg-10 col-xl-8",
            parentclass: "personalize-row row",
            options: {
            }
        });
    };

    self.updateData = () => {
        self.updateBoilerplate().then((bolierplates) => {
            self.getLatestBook().then((bookObj) => {
                let book = bookObj?.savedBook?.parse({}) || {};
                self.setState((prev) => ({
                    ...prev,
                    pages: prev.pages.map((o) => ({ ...o, content: self.getContent(book[o.name] || o.content || bolierplates[o.name] || "", o) }))
                }));
            });
        });
    };

    self.getNoticeMeesage = () => {
        let defaultmessage = "";
        let device = self.$store?.device;
        if(["mob","small","tab", "lap"].includes(device)) {
          defaultmessage+="<br/><span style='font-size:12px; color:#cc3300; font-weight:400;'>Books Best view in Desktop version only</span>";
        }
        return defaultmessage;
      };

    useEffect(() => {
        self.updateData();
    }, []);

    let noticeMessage = self.getNoticeMeesage();
    const { savedBook, pages, overlayStyle } = state;
    const { onSave, onUpdate } = self;

    return (
        <div className='SelfPublish top-margin'>
            <PageEditor
                pagePayload={pages}
                onSave={(...arg) => onSave(...arg, self)}
                onUpdate={onUpdate}
                charcount={100}
                lastPageNo={62}
                overlay={false}
                style={overlayStyle}
                has={["chapter"]}
                pageMode="mono"
                bookDetails={savedBook}
                message={noticeMessage}
            ></PageEditor>
        </div>
    );
}

export default connect(withRouter(SelfPublish));
